import NewProjectComponent from "./newProject.component";

export { default as StepOneComponent } from "./stepOne";
export { default as StepTwoComponent } from "./stepTwo";
export { default as StepThreeComponent } from "./stepThree";
export { default as StepFourComponent } from "./stepFour";
export { default as StepFiveComponent } from "./stepFive";
export { default as PatientOrgStepThree } from "./patientOrgStepThree";
export default NewProjectComponent;
